import {
  APIComponentAttributes,
  APIReferenceAttributes,
} from '@ardoq/api-types';
import { ReferenceFilterContext } from '@ardoq/filter-helpers';
import { GraphInterface } from './graphInterface/graphInterface';

/**
 * Ensures that the `isIncludedInContextByFilter` function is called for
 * all components and references to update and cache formatting filters correctly.
 * Previously, this was achieved by traversing the entire graph as a side
 * effect of the traversal.
 * This design can obviously be improved, but that is quite a bigger task.
 *
 * scopeComponentIds does not always contain the ID of every component which can be displayed in a view.
 * So we use the old Components collection here, noting that allComponents exists as a hack to satisfy
 * the broken FilterCache.
 *
 * @see https://ardoqcom.atlassian.net/browse/ARD-23421
 * @deprecated Callers that build a full `EnhancedScopeData` should use
 * `warmFilterCacheHack` from `apps/ardoq-front/.../collections/warmFilterCacheHack.ts`
 * instead. It bypasses the `graphInterface` / `componentInterface` /
 * `referenceInterface` stub-implementation dispatchers and calls `globalFilters`
 * directly, precomputing per-entity filter data from `scopeData` once.
 */
export const conditionalFormattingFilterCacheHack = (
  graphInterface: GraphInterface,
  allComponents: APIComponentAttributes[],
  allReferences: APIReferenceAttributes[],
  ctx?: ReferenceFilterContext
) => {
  allComponents.forEach(component =>
    graphInterface.isComponentIncludedInContextByFilter(component, ctx)
  );
  allReferences.forEach(reference =>
    graphInterface.isReferenceIncludedInContextByFilter(reference, ctx)
  );
};
